import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconZoomOutRound = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <g clipPath="url(#icon-zoom-out-round__a)">
      <g clipPath="url(#icon-zoom-out-round__b)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M9.909 17.578a1 1 0 0 0 2 0V13.47a1 1 0 0 0-1.001-1l-4.104.004a1 1 0 1 0 .002 2l1.689-.002-4.319 4.319a1 1 0 1 0 1.415 1.414l4.318-4.318v1.691Z"
          clipRule="evenodd"
        />
      </g>
      <g clipPath="url(#icon-zoom-out-round__c)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M14.89 6.393a1 1 0 0 0-2 0V10.5a1 1 0 0 0 1.001 1l4.104-.005a1 1 0 1 0-.002-2l-1.689.002 4.318-4.318a1 1 0 0 0-1.414-1.414L14.89 8.084V6.393Z"
          clipRule="evenodd"
        />
      </g>
    </g>
    <defs>
      <clipPath id="icon-zoom-out-round__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="icon-zoom-out-round__b">
        <path fill="currentColor" d="m15.998 16.485-8.1 8.1-8.1-8.1 8.1-8.1z" />
      </clipPath>
      <clipPath id="icon-zoom-out-round__c">
        <path fill="currentColor" d="m8.8 7.485 8.1-8.1 8.1 8.1-8.1 8.1z" />
      </clipPath>
    </defs>
  </svg>
);
const Memo = memo(SvgIconZoomOutRound);
export default Memo;
